import React from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Button, Card } from "antd";

function AnnouncementDetail() {
  const location = useLocation();
  const { announcement } = location.state;
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/");
  };

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
          <Card
            className="card-professional"
            title="Announcement Details"
            extra={
              <Button className="btn-primary" onClick={handleBack}>
                Back to Dashboard
              </Button>
            }
          >
            <div className="row mb-3">
              <strong className="subject-detail">{announcement.announcement}</strong>
              <br></br>
              <p className="message-detail">{announcement.message}</p>
            </div>
          </Card>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default AnnouncementDetail;
